import { render, staticRenderFns } from "./FormInner.vue?vue&type=template&id=1f6dfe81&scoped=true&"
import script from "./FormInner.vue?vue&type=script&lang=js&"
export * from "./FormInner.vue?vue&type=script&lang=js&"
import style0 from "./FormInner.vue?vue&type=style&index=0&id=1f6dfe81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6dfe81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VForm,VTab,VTabs,VTabsSlider})
